export const educationData = [
    {
        id: 1,
        institution: 'Indian Institute of Information Technology, Sri City',
        course: 'B.Tech (CSE)',
        startYear: '2019',
        endYear: '2023',
        CGPA:'9.09'
    },
    {
        id: 2,
        institution: 'Narayana College of Education, Hyderabad',
        course: 'Secondary Education',
        startYear: '2017',
        endYear: '2019',
        CGPA:'98.6%'
    },
    {
        id: 3,
        institution: "St. Paul's school, Bhadrachalam",
        course: 'Primary Education',
        startYear: '2016',
        endYear: '2017',
        CGPA:'10'
    },
]
